import { computed } from 'vue';
import { useAuthPermissions } from '@/components/auth/permissions';
import { useIntegrationPartnersStore } from '@/stores/integration_partners/integrationPartners';
import IPSV2_PERMISSIONS from '@/utils/constants/integrations_partners_v2/permissions.js';
import DCS_PERMISSIONS from '@/utils/constants/data_consuming_system/permissions';

export function useQuextSetupMenuItem() {
    const { hasAuthPermission, QUEXT_PERMISSIONS: Q_PERM } = useAuthPermissions();

    const { hasPermission, hasRolePermission } = useIntegrationPartnersStore();

    const hasPartnerAccess = computed(() => {
        return hasPermission(IPSV2_PERMISSIONS.CREATE_PARTNER) || hasPermission(IPSV2_PERMISSIONS.UPDATE_PARTNER) || hasRolePermission;
    });

    const hasSyncServiceAccess = computed(() => {
        return hasPermission(DCS_PERMISSIONS.VIEW_SCHEDULES) && hasRolePermission;
    });

    const quextSetupMenuItems = computed(() => ({
        list: [
            {
                permissionChecker: hasAuthPermission.value(Q_PERM.QUEXT_SETUP),
                label: 'Quext setup',
                id: '__quext_setup',
                items: [
                    {
                        icon: 'user',
                        permissionChecker: hasAuthPermission.value(Q_PERM.VIEW_CUSTOMERS),
                        label: 'Customers',
                        id: 'customers.index',
                    },
                    {
                        icon: 'users',
                        permissionChecker:
                            hasAuthPermission.value(Q_PERM.VIEW_PERMISSION_GROUPS) || hasAuthPermission.value(Q_PERM.VIEW_METAROLES),
                        label: 'Customer roles management',
                        id: 'customer_roles_mngmt',
                    },
                    {
                        icon: 'qxt-userpic-default',
                        permissionChecker:
                            hasAuthPermission.value(Q_PERM.VIEW_SUPERADMIN) ||
                            hasAuthPermission.value(Q_PERM.VIEW_QUEXT_USERS) ||
                            hasAuthPermission.value(Q_PERM.VIEW_PRESETS),
                        label: 'Quext users and roles management',
                        id: 'quext_users_roles_mngmt',
                    },
                    {
                        icon: 'view-grid',
                        permissionChecker: hasAuthPermission.value(Q_PERM.VIEW_APPS),
                        label: 'Applications',
                        id: 'application_mngmt.index',
                    },
                    {
                        icon: 'repeat',
                        permissionChecker: hasPartnerAccess.value,
                        label: 'Integration partners',
                        id: 'ips-v2.partner.manage-partner',
                    },
                    {
                        icon: 'refresh-cw',
                        permissionChecker: hasSyncServiceAccess.value,
                        label: 'Sync service',
                        id: 'sync-service.index',
                    },
                    {
                        icon: 'settings',
                        permissionChecker: hasAuthPermission.value(Q_PERM.VIEW_SUPERADMIN),
                        label: 'Reports settings',
                        id: 'dashboard.json-editor',
                    },
                ],
            },
        ],
    }));

    return { quextSetupMenuItems };
}
